var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authentication"},[_c('div',{staticClass:"logo"}),_c('router-view'),_c('Footer',{attrs:{"show-divider":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }